<template>
  <div>
    <div class="s-card" style="margin: 5px 2px">
      <table style="width: 100%">
        <tr>
          <td style="text-align: right;">
            <label>Tipo de veículo:</label>
          </td>
          <td style="width: 200px">
            <select v-model="localValue.vehicleType" style="width: 100%">
              <option value="entrega_moto">moto</option>
              <option value="entrega_carro">carro</option>
            </select>
          </td>
        </tr>
        <tr>
          <td style="text-align: right">
            <label>Código de coleta:</label>
          </td>
          <td>
            <select v-model="localValue.needPickupCode" style="width: 100%">
              <option :value="false">não</option>
              <option :value="true">sim</option>
            </select>
          </td>
        </tr>
        <tr>
          <td style="text-align: right">
            <label>Código de entrega:</label>
          </td>
          <td>
            <select v-model="localValue.needDropoffCode" style="width: 100%">
              <option :value="true">sim</option>
              <option :value="false">não</option>
            </select>
          </td>
        </tr>
        <tr>
          <td style="text-align: right">
            <label>Tipo do pacote:</label>
          </td>
          <td>
            <select v-model="localValue.packageType" style="width: 100%">
              <option value="food">alimentos</option>
              <option value="documents">documentos</option>
              <option value="electronics">eletrônicos</option>
              <option value="groceries">mantimentos</option>
              <option value="medication">medicamentos</option>
              <option value="other">outros</option>
              <option value="wear">vestuário</option>
            </select>
          </td>
        </tr>
        <tr>
          <td style="text-align: right">
            <label>Peso do pacote:</label>
          </td>
          <td>
            <select v-model="localValue.packageWeight" style="width: 100%">
              <option value="1kg">até 1kg</option>
              <option value="5kg">até 5kg</option>
              <option value="10kg">até 10kg</option>
              <option value="20kg">até 20kg</option>
              <option value="30kg">até 30kg</option>
            </select>
          </td>
        </tr>
        <tr>
          <td style="text-align: right">
            <label>Destinatário não localizado:</label>
          </td>
          <td>
            <select v-model="localValue.returnType" style="width: 100%">
              <option value="1">devolver o pacote</option>
              <option value="2">descartar o pacote</option>
            </select>
          </td>
        </tr>
        <tr v-if="localValue.returnType == 1">
          <td style="text-align: right">
            <label>Método de devolução:</label>
          </td>
          <td>
            <select v-model="localValue.returnHandoverMethod"
              style="width: 100%">
              <option value="2">tire uma foto</option>
              <option value="3">código de verificação</option>
            </select>
          </td>
        </tr>
      </table>
      <div v-if="!showConfig"
        style="margin: 12px 0; font-weight: bold; color: #333">
        Status: {{ status }}
      </div>
    </div>
    <div id="footer" style="text-align: right; margin-top: 16px">
      <button @click="$emit('cancel')">Cancelar</button>
      <button v-if="showDisable" @click="$emit('disable')">Remover
        vínculo</button>
      <button v-if="showSend" @click="save('send')">
        <i class="mdi mdi-send mdi-18px">Enviar</i>
      </button>
      <button v-if="showSave" class="btn-primary" @click="save">Salvar</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SEntrega99Info",
  props: {
    value: { type: Object, default: () => ({}) },
    status: { type: String, default: "" },
    showConfig: { type: Boolean, default: false },
  },
  computed: {
    hasOrderId() {
      return !!this?.value?.orderId;
    },
    cancelado() {
      return ["cancelado", "em processo de devolução"].includes(
        this.status,
      );
    },
    showDisable() {
      return !this.showConfig && (!this.hasOrderId || this.cancelado);
    },
    showSend() {
      return !this.showConfig && !this.hasOrderId && !this.cancelado;
    },
    showSave() {
      return !this.cancelado;
    },
  },
  data() {
    return {
      localValue: {
        vehicleType: this.value.vehicleType || "entrega_moto",
        needPickupCode: this.value.needPickupCode || false,
        needDropoffCode: this.value.needDropoffCode !== false,
        returnType: this.value.returnType || "1",
        returnHandoverMethod: this.value.returnHandoverMethod || "2",
        packageType: this.value.packageType || "food",
        packageWeight: this.value.packageWeight || "1kg",
      },
    };
  },
  methods: {
    save(action) {
      this.$emit("save", { ...this.localValue, action });
    },
  },
};
</script>